// extracted by mini-css-extract-plugin
export var root = "CartItem-module--root--3rIxs";
export var imageContainer = "CartItem-module--imageContainer--HzzXc";
export var itemContainer = "CartItem-module--itemContainer--1BBCU";
export var adjustItemContainer = "CartItem-module--adjustItemContainer--YxLjR";
export var priceContainer = "CartItem-module--priceContainer--HB6dM";
export var name = "CartItem-module--name--RXqsD";
export var metaContainer = "CartItem-module--metaContainer--3FTzG";
export var editContainer = "CartItem-module--editContainer--oR39a";
export var removeContainer = "CartItem-module--removeContainer--Syel8";